import LanguagePreferenceSync from "./components/common/LanguagePreferenceSync";
import React, { Component } from "react";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { Route, Routes, BrowserRouter as Router } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.css";
import Register from "../src/components/pages/registration";
import Login from "../src/components/pages/login";
import Alert from "./components/common/Alert";
import Home from "../src/components/pages/home";
import Clients from "../src/components/pages/clients";
import ClientProfilePage from "./components/client/ClientProfilePage";
import Report from "../src/components/pages/reports";
import Projects from "./components/pages/Projects";
import Logout from "./components/common/Logout";
import Tag from "./components/pages/Tag";
import Team from "./components/pages/team";
import ProjectTeam from "./components/Projects/projectteam";
import InvitePage from "./components/pages/InvitePage";
import ProjectInvitePage from "./components/pages/ProjectInvitePage";
import ConfirmationPage from "./components/pages/confirmpage";
import ComingSoon from "../src/components/common/Comingsoon";
import ProfilePage from "../src/components/pages/profilepage";
import Workspace from "../src/components/pages/workspace";
import WorkspaceManage from "../src/components/pages/WorkspaceManage";
import IntegrationsPage from "./components/pages/IntegrationsPage";
import Settings from "../src/components/pages/settings";
import AttendancePage from "../src/components/pages/AttendancePage";
import ComplianceDashboardPage from "../src/components/pages/ComplianceDashboardPage";
import LeavePage from "../src/components/pages/LeavePage";
import HRReportPage from "../src/components/pages/HRReportPage";
import InsightsPage from "../src/components/pages/InsightsPage";
import TracePage from "./components/pages/TracePage";
import DesktopAppPage from "./components/pages/DesktopAppPage";
import InvoicesPage from "./components/pages/InvoicesPage";
import InvoiceEditorPage from "./components/pages/InvoiceEditorPage";
import InvoiceDetailPage from "./components/pages/InvoiceDetailPage";
import InvoiceDocumentPage from "./components/pages/InvoiceDocumentPage";
import InvoiceSettingsPage from "./components/pages/InvoiceSettingsPage";
import ForgotPassword from "../src/components/pages/forgot_password";
import UpdatePassword from "../src/components/pages/update_password";
import AuthRefresh from "./components/common/AuthRefresh";
import GlobalTimerTitle from "./components/common/GlobalTimerTitle";
import ProductTour from "./components/common/ProductTour";

// Redux
import { Provider } from "react-redux";
import configStore from "./store";
import setAuthToken from "./utils/setAuthToken";
import { PersistGate } from "redux-persist/integration/react";
import Reports from "../src/components/pages/reports";
import moment from "moment-timezone";
import InviteReject from "./components/pages/InviteReject";
import ReportCalendar from "./components/Reports/calendar";
import Impressum from "./components/pages/Impressum";
import Datenschutz from "./components/pages/Datenschutz";
import AGB from "./components/pages/AGB";
import SetupWizard from "./components/pages/SetupWizard";
import UpgradePage from "./components/pages/UpgradePage";
import BillingPage from "./components/pages/BillingPage";
import HelpPage from "./components/pages/HelpPage";
import DesktopLinkPage from "./components/pages/DesktopLinkPage";
import PrivateRoute from "./components/common/PrivateRoute";
import HRRoute from "./components/common/HRRoute";
import ProRoute from "./components/common/ProRoute";
import PublicAuthRoute from "./components/common/PublicAuthRoute";
import WithRouter from "./components/common/WithRouter";
import { PlausibleAnalytics } from "./utils/plausible";
import AppVersionWatcher from "./components/common/AppVersionWatcher";


const { store, persistor } = configStore();

export default class App extends Component {
  render() {
    //moment.tz.setDefault("Europe/Berlin");
    return (
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <Provider store={store}>
        <PersistGate persistor={persistor}>
          <AuthRefresh />
          <LanguagePreferenceSync />
          <GlobalTimerTitle />
          <AppVersionWatcher />
          <Router>
            <PlausibleAnalytics />
            <ProductTour />
            <Routes>
              <Route path='/' element={<PublicAuthRoute><WithRouter component={Register} /></PublicAuthRoute>} />
              <Route path='/signup' element={<PublicAuthRoute><WithRouter component={Register} /></PublicAuthRoute>} />
              <Route path='/register' element={<PublicAuthRoute><WithRouter component={Register} /></PublicAuthRoute>} />
              <Route path='/login' element={<PublicAuthRoute><WithRouter component={Login} /></PublicAuthRoute>} />
              <Route path='/desktop-link/:publicCode' element={<WithRouter component={DesktopLinkPage} />} />
              <Route path='/dashboard' element={<PrivateRoute><WithRouter component={Home} /></PrivateRoute>} />
              <Route path='/report' element={<PrivateRoute><WithRouter component={Report} /></PrivateRoute>} />
              <Route path='/clients/new' element={<PrivateRoute><WithRouter component={ClientProfilePage} /></PrivateRoute>} />
              <Route path='/clients/:clientId' element={<PrivateRoute><WithRouter component={ClientProfilePage} /></PrivateRoute>} />
              <Route path='/clients' element={<PrivateRoute><WithRouter component={Clients} /></PrivateRoute>} />
              <Route path='/invoices/new' element={<HRRoute><WithRouter component={InvoiceEditorPage} /></HRRoute>} />
              <Route path='/invoices/:invoiceId/edit' element={<HRRoute><WithRouter component={InvoiceEditorPage} /></HRRoute>} />
              <Route path='/invoices/:invoiceId/document' element={<HRRoute><WithRouter component={InvoiceDocumentPage} /></HRRoute>} />
              <Route path='/invoices/:invoiceId' element={<HRRoute><WithRouter component={InvoiceDetailPage} /></HRRoute>} />
              <Route path='/invoices' element={<HRRoute><WithRouter component={InvoicesPage} /></HRRoute>} />
              <Route path='/invoice-settings' element={<HRRoute><WithRouter component={InvoiceSettingsPage} /></HRRoute>} />
              <Route path='/projects' element={<PrivateRoute><WithRouter component={Projects} /></PrivateRoute>} />
              <Route path='/tag' element={<PrivateRoute><WithRouter component={Tag} /></PrivateRoute>} />
              <Route path='/team' element={<PrivateRoute><WithRouter component={Team} /></PrivateRoute>} />
              <Route path='/project/:id/:slug' element={<PrivateRoute><WithRouter component={ProjectTeam} /></PrivateRoute>} />
              <Route path='/projectteam' element={<PrivateRoute><WithRouter component={ProjectTeam} /></PrivateRoute>} />
              <Route path='/invite' element={<WithRouter component={InvitePage} />} />
              <Route path='/project-invite' element={<WithRouter component={ProjectInvitePage} />} />
              <Route path='/reject' element={<WithRouter component={InviteReject} />} />
              <Route path='/confirm' element={<WithRouter component={ConfirmationPage} />} />
              <Route path='/setup' element={<WithRouter component={SetupWizard} />} />
              <Route path='/logout' element={<WithRouter component={Logout} />} />
              <Route path='/profile' element={<PrivateRoute><WithRouter component={ProfilePage} /></PrivateRoute>} />
              <Route path='/workspace' element={<PrivateRoute><WithRouter component={Workspace} /></PrivateRoute>} />
              <Route path='/workspaces' element={<PrivateRoute><WithRouter component={WorkspaceManage} /></PrivateRoute>} />
              <Route path='/integrations' element={<PrivateRoute><IntegrationsPage /></PrivateRoute>} />
              <Route path='/settings' element={<PrivateRoute><WithRouter component={Settings} /></PrivateRoute>} />
              <Route path='/attendance' element={<HRRoute><WithRouter component={AttendancePage} /></HRRoute>} />
              <Route path='/compliance' element={<HRRoute><WithRouter component={ComplianceDashboardPage} /></HRRoute>} />
              <Route path='/leave' element={<HRRoute><WithRouter component={LeavePage} /></HRRoute>} />
              <Route path='/hr-reports' element={<HRRoute><WithRouter component={HRReportPage} /></HRRoute>} />
              <Route path='/upgrade' element={<PrivateRoute><WithRouter component={UpgradePage} /></PrivateRoute>} />
              <Route path='/reports' element={<ProRoute><WithRouter component={Reports} /></ProRoute>} />
              <Route path='/calendar' element={<PrivateRoute><WithRouter component={ReportCalendar} /></PrivateRoute>} />
              <Route path='/password/forgot' element={<PublicAuthRoute><WithRouter component={ForgotPassword} /></PublicAuthRoute>} />
              <Route path='/password/update' element={<PublicAuthRoute><WithRouter component={UpdatePassword} /></PublicAuthRoute>} />
              <Route path='/subscription' element={<PrivateRoute><WithRouter component={BillingPage} /></PrivateRoute>} />
              <Route path='/training' element={<WithRouter component={ComingSoon} />} />
              <Route path='/mobile-app' element={<WithRouter component={ComingSoon} />} />
              <Route path='/desktop-app' element={<PrivateRoute><WithRouter component={DesktopAppPage} /></PrivateRoute>} />
              <Route path='/blog' element={<WithRouter component={ComingSoon} />} />
              <Route path='/jobs' element={<WithRouter component={ComingSoon} />} />
              <Route path='/insights' element={<ProRoute><WithRouter component={InsightsPage} /></ProRoute>} />
              <Route path='/trace' element={<PrivateRoute><WithRouter component={TracePage} /></PrivateRoute>} />
              <Route path='/help' element={<PrivateRoute><WithRouter component={HelpPage} /></PrivateRoute>} />
              <Route path='/import' element={<WithRouter component={ComingSoon} />} />
              <Route path='/achievements' element={<WithRouter component={ComingSoon} />} />
              <Route path='/impressum' element={<WithRouter component={Impressum} />} />
              <Route path='/datenschutz' element={<WithRouter component={Datenschutz} />} />
              <Route path='/agb' element={<WithRouter component={AGB} />} />
            </Routes>
          </Router>
        </PersistGate>
      </Provider>
      </GoogleOAuthProvider>
    );
  }
}
